import React, { useEffect, useState } from 'react';
import { message, Modal, Spin, Card, Button, Flex, Table as TableAntd } from 'antd';
import { FaPlus } from 'react-icons/fa';
import { Formik, FieldArray } from 'formik';
import { Input } from 'formik-antd';
import { useTranslation } from 'react-i18next';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import Row from '~/components/Row';
import { createPatrimonies, updatePatrimonies } from '~/services/hooks/patrimonies';
import { useCheckAuth } from '~/components/Can/checkAuth';
import { Table } from '~/components/Table';
import { patrimonyPaymentsColumns } from '~/tables/patrimonies';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  name: null,
  patrimony_payments: [],
};

export default function PatrimoniesModal({ visible, patrimonyEdit, onClose, isMobile }) {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initial);

  const savePatrimonies = async (values, { setErrors }) => {
    setLoading(true);
    try {
      if (values.id) {
        await updatePatrimonies(values.id, values);
        message.success(t('messages:successUpdate'));
      } else {
        await createPatrimonies(values);
        message.success(t('messages:successCreate'));
      }

      onClose();
    } catch (error) {
      console.error(error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (patrimonyEdit) {
      return authCheck('@assets/edit');
    } else {
      return authCheck('@assets/create');
    }
  };

  useEffect(() => {
    if (visible) {
      if (patrimonyEdit?.patrimony_payments) {
        setInitialValues(patrimonyEdit);
      }
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={savePatrimonies}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, errors }) => (
        <Modal
          title={t('Patrimônios')}
          onCancel={onClose}
          afterClose={() => setInitialValues(initial)}
          style={{ maxWidth: isMobile ? '100%' : '1500px' }}
          open={visible}
          centered
          width="1300px"
          footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} />}
        >
          <Spin spinning={loading}>
            <Card>
              <Row>
                <FormControl cols={{ sm: 12, xs: 24 }} field="name" label={t('Nome')}>
                  <Input name="name" disabled={!fluidPermissions()} />
                </FormControl>
              </Row>
              <FieldArray name="patrimony_payments">
                {({ push, remove }) => (
                  <Table
                    dataSource={values?.patrimony_payments?.map((pp, i) => ({
                      ...pp,
                      key: i,
                      remove,
                    }))}
                    columns={patrimonyPaymentsColumns(errors, fluidPermissions, setFieldValue)}
                    size="small"
                    rowClassName={() => 'editable-row'}
                    bordered
                    empty={false}
                    summary={() => {
                      return (
                        <TableAntd.Summary.Row>
                          <TableAntd.Summary.Cell>
                            <Flex style={{ height: '100%' }} align="flex-start" justify="center">
                              <Button
                                color="primary"
                                title="Adicionar modalidade"
                                size="small"
                                onClick={() => push({ description: null, acquired_at: null, price: null })}
                                style={{ width: '30px' }}
                                disabled={!fluidPermissions()}
                              >
                                <FaPlus />
                              </Button>
                            </Flex>
                          </TableAntd.Summary.Cell>
                        </TableAntd.Summary.Row>
                      );
                    }}
                  />
                )}
              </FieldArray>
            </Card>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
